import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';
import {UserVO} from '../../generate/UserVO';
import {AuthService} from '../../services/auth.service';
import {HistoryHelperService} from "../../services/history-helper.service";

declare var jQuery: any;

@Component({
  selector: 'navigation-bar',
  templateUrl: './navigation-bar.component.html',
  styleUrls: ['./navigation-bar.component.scss']
})
export class NavigationBarComponent implements OnInit {
  user: UserVO;

  @Output()
  navigateToSettings = new EventEmitter<void>();

  constructor(private authService: AuthService, private router: Router, private historyHelperService: HistoryHelperService) {
  }

  ngOnInit() {
    this.user = this.authService.currentUserAuthVO();
    try {
      jQuery('ul').foundation();
    } catch (e) {

    }
  }

  navigateToUserSettings() {
    this.navigateToSettings.emit();
  }

  logout() {
    this.historyHelperService.deleteHistory(HistoryHelperService.URL_KEY);
    this.authService.logout('', true);
    this.router.navigateByUrl('/home');
  }
}
